export default __webpack_public_path__ + "img/square_0.0708a62dad92f3cdb5dbad8d2a18280f.jpg";